import { gql } from '@apollo/client';

export const TRACK_PERSON_MENTION_PAGE_VISIT = gql`
  mutation TrackPersonMentionPageVisit(
    $input: TrackPersonMentionPageVisitInput!
  ) {
    trackPersonMentionPageVisit(input: $input)
  }
`;
